import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { IAutocompleteEntry, CompletionType } from 'utils/entities';
import { resolvedStrictLocalDocSelector } from 'store/state/domainData/selectors';
import HoodPage from './HoodPage/';
import CityPage from './CityPage/';
import withEvents from 'analytics/withEvents';
import { createDetailPageSectionHandlers, DetailPageEventCategory } from 'analytics/handlers/detailPageSectionHandlers';
import { Section as SectionEnum } from 'components/navigation/subheader/SectionsNavigation';
import { setVisibleSection } from 'store/state/app/actions';


interface AreaPageProps {
  strictLocalDoc: IAutocompleteEntry;
  setVisibleSection: (section: SectionEnum) => void;
}

const AreaPage: React.FC<AreaPageProps> = (props) => {
  const { strictLocalDoc, ...rest } = props;
  if (!strictLocalDoc) return null;

  if (strictLocalDoc.type === CompletionType.Neighbourhood) return <HoodPage {...rest} />;
  return <CityPage {...rest} />;
};

const AreaPageWithEvents = withEvents<AreaPageProps>(createDetailPageSectionHandlers(DetailPageEventCategory.LocalPage))(AreaPage);

const mapStateToProps = (state: State) => ({
  strictLocalDoc: resolvedStrictLocalDocSelector(state),
});

const mapDispatchToProps = {
  setVisibleSection,
};

export default connect(mapStateToProps, mapDispatchToProps)(AreaPageWithEvents);
